import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { 
  Package, 
  User, 
  Menu, 
  X, 
  LogOut, 
  Plus,
  Search,
  ChevronDown,
  ArrowLeft,
  Bell,
  Award,
  Shield,
  ChevronRight,
  FileText,
  Lock,
  LayoutDashboard,
  Phone,
  Mail,
  MapPin,
  ArrowUp
} from 'lucide-react';
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Badge } from "@/components/ui/badge";
import { toast } from 'sonner';
import { useAuth } from '@/lib/AuthContext';
import WeatherCarousel from '@/components/WeatherCarousel';

// ==========================================
// ÍCONES SVG DAS REDES SOCIAIS (inline)
// ==========================================
const WhatsAppIcon = ({ className }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 24 24">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

const FacebookIcon = ({ className }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 24 24">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

const InstagramIcon = ({ className }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 24 24">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 100-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
  </svg>
);

const TwitterIcon = ({ className }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 24 24">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>
);

const LinkedInIcon = ({ className }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 24 24">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

export default function Layout({ children, currentPageName }) {
  const { user, isAuthenticated, logout, isLoading } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [legalDropdownOpen, setLegalDropdownOpen] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  
  const isEmpresa = user?.tipo === 'empresa' || user?.isEmpresa || user?.cnpj;
  const nivelMotorista = !isEmpresa && user?.nivel ? user.nivel : null;
  const entregasRealizadas = user?.entregasRealizadas || 0;

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
      setShowScrollTop(window.scrollY > 400);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (legalDropdownOpen && !event.target.closest('.legal-dropdown-container')) {
        setLegalDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [legalDropdownOpen]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const mainPages = ['Home', 'BuscarCargas', 'Perfil', 'MinhasCargas', 'QuemSomos', 'PoliticaPrivacidade', 'TermosDeUso', 'TermosSegurancaCarga', 'TermoResponsabilidade', 'PainelMotorista'];
  const showBackButton = !mainPages.includes(currentPageName);

  const handleLogout = () => {
    logout();
    toast.success('Você saiu da conta');
    navigate('/');
  };

  const handleLogin = () => {
    navigate('/login');
  };

  const navItems = [
    { name: 'Início', path: '/', icon: Package },
    { name: 'Buscar Cargas', path: '/buscar-cargas', icon: Search },
    { name: 'Quem Somos', path: '/quem-somos', icon: User },
  ];

  const legalLinks = [
    { to: '/politica-privacidade', icon: Lock, label: 'Política de Privacidade' },
    { to: '/termo-responsabilidade', icon: FileText, label: 'Termo de Responsabilidade' },
    { to: '/termo-seguranca-carga', icon: Shield, label: 'Proteção de Carga' },
    { to: '/termos-de-uso', icon: FileText, label: 'Termos de Uso' },
  ];

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-950 pb-20 md:pb-0">
      
      {/* HEADER */}
      <header 
        className={`sticky top-0 z-50 transition-all duration-300 select-none ${
          scrolled 
            ? 'bg-white/95 dark:bg-slate-900/95 backdrop-blur-md shadow-lg border-b border-slate-200/50 dark:border-slate-800/50' 
            : 'bg-white dark:bg-slate-900 border-b border-slate-200 dark:border-slate-800'
        }`}
        style={{ paddingTop: 'env(safe-area-inset-top)' }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            
            <div className="flex items-center gap-4">
              {showBackButton && (
                <button
                  onClick={() => navigate(-1)}
                  className="md:hidden p-2 -ml-2 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
                >
                  <ArrowLeft className="w-6 h-6 text-slate-600 dark:text-slate-300" />
                </button>
              )}
              
              <Link to="/" className="flex items-center gap-3 group">
                <img src="/logoborinho45.png" alt="Borinho" className="w-10 h-10 object-contain" />
                <span className="text-xl font-bold text-slate-900 dark:text-white">
                  Bora<span className="text-brand-500">Frete</span>
                </span>
              </Link>
            </div>

            <nav className="hidden md:flex items-center gap-1">
              {navItems.map((item) => {
                const isActive = location.pathname === item.path;
                return (
                  <Link key={item.path} to={item.path}
                    className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                      isActive ? 'bg-brand-500/10 text-brand-600' : 'text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800'
                    }`}>
                    {item.name}
                  </Link>
                );
              })}
            </nav>

            <div className="flex items-center gap-3">
              {!isLoading && (
                <>
                  {isAuthenticated ? (
                    <>
                      {!isEmpresa && nivelMotorista && (
                        <div className={`hidden md:flex ${nivelMotorista.cor} text-white px-3 py-1.5 rounded-full text-xs font-bold items-center gap-1.5 shadow-md`}
                          title={`${entregasRealizadas} entregas realizadas`}>
                          <Award className="w-3.5 h-3.5" />{nivelMotorista.nome}
                        </div>
                      )}

                      {isEmpresa && (
                        <Link to="/nova-carga" className="hidden sm:block">
                          <Button className="bg-brand-500 hover:bg-brand-600 text-white gap-2 shadow-md hover:shadow-lg transition-all">
                            <Plus className="w-4 h-4" />Publicar Carga
                          </Button>
                        </Link>
                      )}

                      {!isEmpresa && (
                        <Link to="/buscar-cargas" className="hidden sm:block">
                          <Button variant="outline" className="border-brand-500 text-brand-600 hover:bg-brand-50 gap-2">
                            <Search className="w-4 h-4" />Buscar Cargas
                          </Button>
                        </Link>
                      )}

                      <button className="hidden md:flex p-2 rounded-lg text-slate-500 hover:text-brand-500 hover:bg-brand-500/10 transition-colors relative">
                        <Bell className="w-5 h-5" />
                        <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-brand-500 rounded-full border-2 border-white dark:border-slate-900 animate-pulse"></span>
                      </button>
                      
                      <DropdownMenu>
                        <DropdownMenuTrigger asChild>
                          <button className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors">
                            <div className={`w-8 h-8 rounded-full flex items-center justify-center text-white text-sm font-medium shadow-sm ${isEmpresa ? 'bg-blue-600' : 'bg-gradient-to-br from-brand-700 to-brand-900'}`}>
                              {user?.nome?.charAt(0) || user?.email?.charAt(0) || 'U'}
                            </div>
                            <div className="hidden md:block text-left">
                              <p className="text-xs font-medium text-slate-900 dark:text-slate-100">{user?.nome?.split(' ')[0] || 'Usuário'}</p>
                              <p className="text-[10px] text-slate-500">{isEmpresa ? 'Empresa' : 'Motorista'}</p>
                            </div>
                            <ChevronDown className="w-4 h-4 text-slate-500 dark:text-slate-400" />
                          </button>
                        </DropdownMenuTrigger>
                        <DropdownMenuContent align="end" className="w-56">
                          <div className="px-3 py-2 border-b border-slate-100 dark:border-slate-800">
                            <div className="flex items-center gap-2">
                              <p className="font-medium text-sm text-slate-900 dark:text-slate-100">{user?.nome || 'Usuário'}</p>
                              <Badge className={isEmpresa ? 'bg-blue-100 text-blue-800 text-[10px]' : 'bg-green-100 text-green-800 text-[10px]'}>
                                {isEmpresa ? 'Empresa' : 'Motorista'}
                              </Badge>
                            </div>
                            {!isEmpresa && (
                              <p className="text-xs text-slate-500 dark:text-slate-400 mt-1">
                                {entregasRealizadas} entregas • {nivelMotorista?.nome}
                              </p>
                            )}
                          </div>

                          <DropdownMenuItem asChild className="cursor-pointer">
                            <Link to="/perfil" className="flex items-center gap-2">
                              <User className="w-4 h-4 text-slate-500" />Meu Perfil
                            </Link>
                          </DropdownMenuItem>

                          {!isEmpresa && (
                            <DropdownMenuItem asChild className="cursor-pointer">
                              <Link to="/painel" className="flex items-center gap-2">
                                <LayoutDashboard className="w-4 h-4 text-slate-500" />Painel do Motorista
                              </Link>
                            </DropdownMenuItem>
                          )}

                          {!isEmpresa && (
                            <DropdownMenuItem asChild className="cursor-pointer">
                              <Link to="/meus-veiculos" className="flex items-center gap-2">
                                <Package className="w-4 h-4 text-slate-500" />Meus Veículos
                              </Link>
                            </DropdownMenuItem>
                          )}

                          {isEmpresa && (
                            <>
                              <DropdownMenuItem asChild className="cursor-pointer">
                                <Link to="/minhas-cargas" className="flex items-center gap-2">
                                  <Package className="w-4 h-4 text-slate-500" />Minhas Cargas Publicadas
                                </Link>
                              </DropdownMenuItem>
                              <DropdownMenuItem asChild className="cursor-pointer">
                                <Link to="/minhas-propostas" className="flex items-center gap-2">
                                  <Package className="w-4 h-4 text-slate-500" />Propostas Recebidas
                                </Link>
                              </DropdownMenuItem>
                            </>
                          )}

                          <DropdownMenuSeparator />
                          <DropdownMenuItem onClick={handleLogout} className="cursor-pointer text-red-600 focus:text-red-600 focus:bg-red-50 dark:focus:bg-red-950/50">
                            <LogOut className="w-4 h-4 mr-2" />Sair
                          </DropdownMenuItem>
                        </DropdownMenuContent>
                      </DropdownMenu>
                    </>
                  ) : (
                    <Button onClick={handleLogin} className="bg-brand-500 hover:bg-brand-600 text-white shadow-md hover:shadow-lg transition-all">
                      Entrar
                    </Button>
                  )}
                </>
              )}

              {!showBackButton && (
                <button className="md:hidden p-2 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
                  onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
                  {mobileMenuOpen ? <X className="w-6 h-6 text-slate-600 dark:text-slate-300" /> : <Menu className="w-6 h-6 text-slate-600 dark:text-slate-300" />}
                </button>
              )}
            </div>
          </div>
        </div>

        {/* Menu Mobile */}
        {mobileMenuOpen && (
          <div className="md:hidden border-t border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900">
            <nav className="px-4 py-3 space-y-1">
              {navItems.map((item) => {
                const Icon = item.icon;
                const isActive = location.pathname === item.path;
                return (
                  <Link key={item.path} to={item.path} onClick={() => setMobileMenuOpen(false)}
                    className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                      isActive ? 'bg-brand-500/10 text-brand-600' : 'text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800'
                    }`}>
                    <Icon className="w-5 h-5" />{item.name}
                  </Link>
                );
              })}
              
              <div className="h-px bg-slate-200 dark:bg-slate-800 my-2"></div>
              <p className="px-4 py-2 text-xs font-semibold text-slate-500 uppercase">Documentos Legais</p>
              
              {legalLinks.map((link) => {
                const Icon = link.icon;
                const isActive = location.pathname === link.to;
                return (
                  <Link key={link.to} to={link.to} onClick={() => setMobileMenuOpen(false)}
                    className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                      isActive ? 'bg-brand-500/10 text-brand-600' : 'text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800'
                    }`}>
                    <Icon className="w-5 h-5" />{link.label}
                  </Link>
                );
              })}

              {isAuthenticated && (
                <>
                  <div className="h-px bg-slate-200 dark:bg-slate-800 my-2"></div>
                  {!isEmpresa && nivelMotorista && (
                    <div className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium ${nivelMotorista.cor} text-white`}>
                      <Award className="w-5 h-5" />{nivelMotorista.nome} • {entregasRealizadas} entregas
                    </div>
                  )}
                  {!isEmpresa && (
                    <Link to="/painel" onClick={() => setMobileMenuOpen(false)}
                      className="flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium bg-brand-600 text-white">
                      <LayoutDashboard className="w-5 h-5" />Painel do Motorista
                    </Link>
                  )}
                  {isEmpresa && (
                    <Link to="/nova-carga" onClick={() => setMobileMenuOpen(false)}
                      className="flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium bg-brand-500 text-white">
                      <Plus className="w-5 h-5" />Publicar Carga
                    </Link>
                  )}
                  {!isEmpresa && (
                    <Link to="/buscar-cargas" onClick={() => setMobileMenuOpen(false)}
                      className="flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium bg-green-500 text-white">
                      <Search className="w-5 h-5" />Buscar Cargas
                    </Link>
                  )}
                  <button onClick={() => { setMobileMenuOpen(false); handleLogout(); }}
                    className="w-full flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-950/20">
                    <LogOut className="w-5 h-5" />Sair
                  </button>
                </>
              )}
            </nav>
          </div>
        )}
      </header>

      {/* ==========================================
          CARROSSEL DE TEMPO — ABAIXO DO HEADER
          ========================================== */}
      <WeatherCarousel />

      {/* CONTEÚDO PRINCIPAL */}
      <main className="min-h-screen">{children}</main>

      {/* SCROLL TO TOP */}
      <button onClick={scrollToTop}
        className={`fixed bottom-6 right-6 z-50 p-3 rounded-full border border-slate-600/30 bg-slate-800/80 backdrop-blur-sm text-slate-400 hover:text-white hover:bg-slate-700 hover:border-slate-500/50 transition-all duration-500 ease-out transform ${
          showScrollTop ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0 pointer-events-none'
        }`}
        aria-label="Voltar ao topo" title="Voltar ao topo">
        <ArrowUp className="w-4 h-4" strokeWidth={1.5} />
      </button>

      {/* FOOTER BLACK CLEAN */}
      <footer className="relative mt-auto overflow-hidden hidden md:block bg-[#0a0a0a]">
        <div className="absolute inset-0 bg-gradient-to-b from-[#0f172a]/30 via-[#0a0a0a] to-[#050505]" />

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 text-white">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
            
            <div className="md:col-span-1">
              <div className="flex items-center gap-3 mb-4">
                <img src="/logoborinho45.png" alt="Borinho" className="w-12 h-12 object-contain" />
                <span className="text-2xl font-bold text-white">Bora<span className="text-blue-400">Frete</span></span>
              </div>
              <p className="text-slate-500 text-sm leading-relaxed">
                Conectando motoristas autônomos e frotas às melhores cargas do Brasil.
              </p>
            </div>

            <div>
              <h4 className="font-bold mb-5 text-blue-400 text-sm uppercase tracking-wider">Para Motoristas</h4>
              <ul className="space-y-3 text-sm text-slate-400">
                <li><Link to="/buscar-cargas" className="hover:text-white transition-colors duration-200 flex items-center gap-2">
                  <ChevronRight className="w-3 h-3 text-blue-500" />Buscar Cargas</Link></li>
                <li><Link to="/cadastro-motorista" className="hover:text-white transition-colors duration-200 flex items-center gap-2">
                  <ChevronRight className="w-3 h-3 text-blue-500" />Cadastrar-se</Link></li>
                <li><Link to="/login" className="hover:text-white transition-colors duration-200 flex items-center gap-2">
                  <ChevronRight className="w-3 h-3 text-blue-500" />Área do Motorista</Link></li>
                <li><span className="hover:text-white transition-colors duration-200 cursor-pointer flex items-center gap-2">
                  <ChevronRight className="w-3 h-3 text-blue-500" />Como Funciona</span></li>
              </ul>
            </div>

            <div>
              <h4 className="font-bold mb-5 text-blue-400 text-sm uppercase tracking-wider">Para Empresas</h4>
              <ul className="space-y-3 text-sm text-slate-400">
                <li><Link to="/nova-carga" className="hover:text-white transition-colors duration-200 flex items-center gap-2">
                  <ChevronRight className="w-3 h-3 text-blue-500" />Publicar Carga</Link></li>
                <li><Link to="/cadastro-empresa" className="hover:text-white transition-colors duration-200 flex items-center gap-2">
                  <ChevronRight className="w-3 h-3 text-blue-500" />Cadastrar Empresa</Link></li>
                <li><Link to="/login" className="hover:text-white transition-colors duration-200 flex items-center gap-2">
                  <ChevronRight className="w-3 h-3 text-blue-500" />Área da Empresa</Link></li>
                <li><span className="hover:text-white transition-colors duration-200 cursor-pointer flex items-center gap-2">
                  <ChevronRight className="w-3 h-3 text-blue-500" />Preços e Taxas</span></li>
              </ul>
            </div>

            <div>
              <h4 className="font-bold mb-5 text-blue-400 text-sm uppercase tracking-wider">Fale Conosco</h4>
              <div className="space-y-3 text-sm text-slate-400 mb-6">
                <p className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-lg bg-blue-500/10 flex items-center justify-center">
                    <Phone className="w-4 h-4 text-blue-400" /></div>(65) 98118-1997
                </p>
                <p className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-lg bg-blue-500/10 flex items-center justify-center">
                    <Mail className="w-4 h-4 text-blue-400" /></div>contato@borafrete.com.br
                </p>
                <p className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-lg bg-blue-500/10 flex items-center justify-center">
                    <MapPin className="w-4 h-4 text-blue-400" /></div>Cuiabá, Mato Grosso
                </p>
              </div>
              
              {/* ==========================================
                  REDES SOCIAIS - NOVO
                  ========================================== */}
              <div className="mb-6">
                <p className="text-xs text-slate-500 mb-3 uppercase tracking-wider font-semibold">Siga-nos</p>
                <div className="flex items-center gap-3">
                  <a 
                    href="https://www.facebook.com/profile.php?id=61590357605236&locale=pt_BR" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="w-10 h-10 rounded-lg bg-blue-600/20 hover:bg-blue-600/40 flex items-center justify-center transition-all duration-200 hover:scale-110"
                    title="Facebook"
                  >
                    <FacebookIcon className="w-5 h-5 text-blue-400" />
                  </a>
                  <a 
                    href="https://www.instagram.com/borafrete____/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="w-10 h-10 rounded-lg bg-pink-600/20 hover:bg-pink-600/40 flex items-center justify-center transition-all duration-200 hover:scale-110"
                    title="Instagram"
                  >
                    <InstagramIcon className="w-5 h-5 text-pink-400" />
                  </a>
                  <a 
                    href="https://x.com/borafrete" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="w-10 h-10 rounded-lg bg-slate-600/20 hover:bg-slate-600/40 flex items-center justify-center transition-all duration-200 hover:scale-110"
                    title="X (Twitter)"
                  >
                    <TwitterIcon className="w-5 h-5 text-slate-400" />
                  </a>
                  <a 
                    href="https://www.linkedin.com/in/bora-frete-10a609412/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="w-10 h-10 rounded-lg bg-blue-700/20 hover:bg-blue-700/40 flex items-center justify-center transition-all duration-200 hover:scale-110"
                    title="LinkedIn"
                  >
                    <LinkedInIcon className="w-5 h-5 text-blue-500" />
                  </a>
                </div>
              </div>
              
              <div className="bg-slate-800/50 backdrop-blur-sm rounded-xl p-4 border border-slate-700/30">
                <p className="text-xs text-slate-500 mb-3">Receba cargas por WhatsApp</p>
                <a href="https://wa.me/5565981181997?text=Quero receber cargas no WhatsApp"
                  target="_blank" rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 bg-green-600 hover:bg-green-500 px-4 py-2.5 rounded-lg transition-all duration-200 text-white text-sm font-medium w-full justify-center shadow-lg shadow-green-900/20 hover:shadow-green-900/40">
                  <Phone className="w-4 h-4" />Quero Receber
                </a>
              </div>
            </div>
          </div>
          
          <div className="border-t border-slate-800/50 mt-12 pt-8">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4">
              <p className="text-sm text-slate-600">© 2026 BoraFrete. Todos os direitos reservados.</p>
              <div className="flex flex-wrap gap-4 text-sm items-center justify-center">
                <Link to="/politica-privacidade" className="text-slate-600 hover:text-white transition-colors duration-200">Privacidade</Link>
                <Link to="/termos-de-uso" className="text-slate-600 hover:text-white transition-colors duration-200">Termos</Link>
                <Link to="/termo-responsabilidade" className="text-slate-600 hover:text-white transition-colors duration-200">Responsabilidade</Link>
                <Link to="/termo-seguranca-carga" className="text-slate-600 hover:text-white transition-colors duration-200 flex items-center gap-1">
                  <Shield className="w-3 h-3" />Proteção de Carga</Link>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}